import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSessionContext } from "../../../../contexts/SessionContext";
import { BundlePatientSummary } from "../../../../services/fhir";
import { HTTPResponseStatus } from "../../../../utils/enum";
import { useFhirData } from "../../../../utils/useFhirData";
import { PatientDocs } from "../../../ehrrecords/components/patientSummaryAccordions/Documents/PatientDocs";
import { ScheduleForDash } from "../ScheduleForDash";
import { PatientQuestionnaireTasksSection } from "./components/PatientQuestionnaireTasksSection";
import { MoreOptionsWeb } from "./compontents/MoreOptionsWeb";
import { FitnessDataModal } from "./compontents/FitnessDataModal";
export function WebPatient() {
  const { user } = useSessionContext();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState<boolean>(true);
  const [summaryData, setSummaryData] = useState();
  const [refetch, setRefetch] = useState<boolean>(false);
  const [openFitnessModal, setOpenFitnessModal] = useState(false);
  const navigate = useNavigate();

  const medicalNoteData = useFhirData.extractPatientSummaryResource(
    summaryData,
    "DocumentReference",
    "prescricao",
  )?.[0]?.entry;

  const solicitationData = useFhirData.extractPatientSummaryResource(
    summaryData,
    "DocumentReference",
    "service-request",
  )?.[0]?.entry;

  const NoteReportData = useFhirData.extractPatientSummaryResource(
    summaryData,
    "DocumentReference",
    "atestado",
  )?.[0]?.entry;

  useEffect(() => {
    async function GetBundle() {
      setLoading(true);
      try {
        const bundleResponse = await BundlePatientSummary({
          identifier: user?.username,
          purposeofuse: "Atendimento",
        });

        if (bundleResponse.status === HTTPResponseStatus.Forbidden) {
          navigate("/");
        }
        setSummaryData(bundleResponse);
      } catch (err) {
        console.log("PatientSummary error:", err);
      } finally {
        setLoading(false);
      }
    }
    if (user?.username) GetBundle();
  }, [refetch, navigate, user]);

  useEffect(() => {
    const shouldReopenModal =
      localStorage.getItem("reopenFitnessModalAfterLink") === "true";
    if (!shouldReopenModal) return;
    if (!user?.refreshTokenGoogleFit) return;

    setOpenFitnessModal(true);
    localStorage.removeItem("reopenFitnessModalAfterLink");
  }, [user?.refreshTokenGoogleFit]);

  return (
    <Stack spacing={2} sx={{ p: 1 }}>
      {/* Primeira linha: Mais opções */}
      <Box sx={{ display: "flex", gap: 2, height: "auto" }}>
        <Box
          sx={{
            width: "100%",
            borderRadius: "8px",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <MoreOptionsWeb onOpenFitnessData={() => setOpenFitnessModal(true)} />
        </Box>
      </Box>

      <PatientQuestionnaireTasksSection variant="tutor" />

      {/* Segunda linha: Agendamentos e Documentos */}
      <Box sx={{ display: "flex", gap: 2, height: "calc(100vh - 200px)" }}>
        <Box
          sx={{
            width: "50%",
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.06)",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <ScheduleForDash />
        </Box>

        <Box
          sx={{
            width: "50%",
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.06)",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <PatientDocs
            setRefetch={setRefetch}
            sign
            medicalNoteData={medicalNoteData}
            solicitationData={solicitationData}
            resultsData={useFhirData.extractPatientSummaryResource(
              summaryData,
              "DocumentReference",
              "resultado",
            )}
            NoteReportData={NoteReportData}
            summaryData={summaryData}
          />
        </Box>
      </Box>
      <FitnessDataModal
        open={openFitnessModal}
        onClose={() => setOpenFitnessModal(false)}
        refreshToken={user?.refreshTokenGoogleFit || ""}
      />
    </Stack>
  );
}
